import { Box, Typography, styled, Dialog, IconButton } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    minHeight: '400px',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-28px -28px 0 0',
  height: 'fit-content',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const Title = styled(Typography)(() => ({
  fontSize: '22px',
  fontWeight: '600',
  color: '#595959',
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: '600px',
  minHeight: '200px',
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
}));

export const TextTypography = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: '600',
  color: '#595959',
}));
